import gql from 'graphql-tag';

const locationQuery = gql`
  query locationQuery($query: String!) {
    locations(query: $query, limit: 5) {
      id
      zipcode
      city
      county
      stateName
      stateCode
      cbsa
    }
  }
`;

export { locationQuery };
